/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-tag-location */
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import { withTranslation } from 'react-i18next';

import { CommaSeparator, GetFormat, isOverDue } from '../../AppUtil/AppUtil';
import LoanService from '../../Service/LoanService';
import Loader from '../Common/Loader';

import PageHeaderTitle from '../Common/Profile/PageHeaderTitle';

import MobileFooter from '../Common/Profile/MobileFooter';
import ModalDisclaimer from '../Common/Profile/ModalDisclaimer';
import ModalFooter from '../Common/Profile/ModalFooter';
import ModalHelp from '../Common/Profile/ModalHelp';
import DisclaimerIcon from '../Common/Profile/SvgIcon/DisclaimerIcon';
import InclaimationIcon from '../Common/Profile/SvgIcon/InclaimationIcon';
import NeedHelpIcon from '../Common/Profile/SvgIcon/NeedHelpIcon';
import QuestionIcon from '../Common/Profile/SvgIcon/QuestionIcon';
import './style.css';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { hot } from 'react-hot-loader';

const LOAN_STATES = window.AppConfig.LOAN_STATES;
const API_URLS = window.AppConfig.API_URLS;

const styles = theme => ({
	table: {
		minWidth: 700
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	blockdiv: {
		textAlign: 'center'
	}
});

const StyledTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.primary.dark,
		color: theme.palette.common.white
	},
	body: {
		fontSize: 14
	}
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.background.default
		}
	}
}))(TableRow);

class List extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false
		};
	}

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	deleteLoanRequest = async id => {
		try {
			this.startLoader();
			await LoanService.delete(`${API_URLS.LOAN}/${id}`);
			this.stopLoader();
			await this.props.refreshState();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	setScreenThroughRouters = () => {
		if (
			this.props.props.match.path === '/loan/:id' ||
			this.props.props.match.path === '/amortization-table/:id' ||
			this.props.props.match.path === '/modify-loan/:id'
		) {
			this.props.openLoanDetail(this.props.props.match.params.id);
		}
	};

	componentDidMount() {
		this.setScreenThroughRouters();
	}

	setScreenThroughRouters = () => {
		if (
			this.props.props.match.path === '/loan/:id' ||
			this.props.props.match.path === '/amortization-table/:id' ||
			this.props.props.match.path === '/modify-loan/:id'
		) {
			this.props.openLoanDetail(this.props.props.match.params.id);
		}
	};

	componentDidMount() {
		this.setScreenThroughRouters();
	}

	render() {
		// NOSONAR
		const { classes } = this.props;
		const { t } = this.props;

		// sort object by id desc
		this.props.LoanObjects.sort((lobj1, lobj2) => {
			if (lobj1.id < lobj2.id) {
				return 1;
			} else {
				if (lobj2.id > lobj1.id) {
					return -1;
				} else {
					return 0;
				}
			}
		});

		let tableType = this.props.tableType.toLowerCase();
		const columns = {
			first_type:
				tableType === 'lend'
					? ['Loan ID', 'Borrower Name', 'Loan Amount']
					: ['Loan ID', 'Lender Name', 'Loan Amount'],
			second_type: null
		};
		const loanObjectsData = this.props.LoanObjects.filter((data, index) => {
			if (
				this.props.parentState._pageHeaderTitle === 'Offers' &&
				// (data.state.toLowerCase() === 'pending' || data.state.toLowerCase() === 'drafted') &&
				data.state.toLowerCase() === 'pending' && // lend tab
				data.loan_type.toLowerCase() === 'lend' &&
				// this.props.currentUserId == data.created_by &&
				this.props.currentUserId == data.created_by &&
				this.props.currentUserId !== data.accepted_by
			) {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Offers' &&
				(data.state.toLowerCase() === 'pending' || data.state.toLowerCase() === 'drafted') &&
				// this.props.currentUserId !== data.created_by
				data.loan_type.toLowerCase() === 'lend' && // borrower tab
				this.props.currentUserId !== data.created_by &&
				this.props.currentUserId == data.accepted_by
			) {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Requests' &&
				(data.state.toLowerCase() === 'pending' || data.state.toLowerCase() === 'drafted') &&
				data.loan_type.toLowerCase() === 'borrow' && // borrower tab
				this.props.currentUserId == data.created_by &&
				this.props.currentUserId !== data.accepted_by
			) {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Requests' &&
				// (data.state.toLowerCase() === 'pending' || data.state.toLowerCase() === 'drafted') &&
				data.state.toLowerCase() === 'pending' &&
				data.loan_type.toLowerCase() === 'borrow' &&
				// this.props.currentUserId === data.created_by
				this.props.currentUserId !== data.created_by &&
				this.props.currentUserId === data.accepted_by
			) {
				return true;
			} else if (this.props.parentState._pageHeaderTitle === 'Active' && data.state.toLowerCase() === 'approve') {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Declined' &&
				data.state.toLowerCase() === 'decline'
			) {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Completed' &&
				data.state.toLowerCase() === 'completed'
			) {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Modified' &&
				(data.state.toLowerCase() === 'pre_modified' || data.state.toLowerCase() === 'post_modified')
			) {
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Paused' &&
				(data.state.toLowerCase() === 'paused' || data.state.toLowerCase() === 'payments_stoped')
			) {
				return true;
			} else if (this.props.parentState._pageHeaderTitle === '') {
				if (this.props.currentUserId === data.created_by) {
					if (data.loan_type.toLowerCase() === 'lend') {
						this.props.parentState._tableColor = '#76C4EE'; // blue
					} else {
						this.props.parentState._tableColor = '#FFC107';
					}
				} else {
					if (data.loan_type.toLowerCase() === 'lend') {
						this.props.parentState._tableColor = '#FFC107';
					} else {
						this.props.parentState._tableColor = '#76C4EE';
					}
				}
				return true;
			} else if (
				this.props.parentState._pageHeaderTitle === 'Drafted' &&
				data.state.toLowerCase() === 'drafted'
			) {
				return true;
			} else {
				return false;
			}
		});

		const Footer = () => {
			return (
				<>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginTop: '20px',
							width: '100%',
							paddingLeft: '40px',
							paddingRight: '40px'
						}}>
						<DisclaimerIcon
							onClick={() => {
								this.setTypeModal('disclaimer');
								this.setIsModalOpen();
							}}
						/>
						<NeedHelpIcon
							onClick={() => {
								this.setTypeModal('needhelp');
								this.setIsModalOpen();
							}}
						/>
					</div>

					<ModalFooter
						open={this.state._isModalOpen}
						typeModal={this.state._typeModal}
						content={
							this.state._typeModal === 'disclaimer' ? (
								<ModalDisclaimer icon={<InclaimationIcon />} />
							) : (
								<ModalHelp
									email="contact@lendami.com.ph"
									number="+639176544580"
									icon={<QuestionIcon />}
								/>
							)
						}
						setIsModalOpen={this.setIsModalOpen}
					/>
				</>
			);
		};

		const getOverDueById = id => {
			const test = this.props.borrowAcceptData
				.flatMap(m => m.installments)
				.filter(m => m.state === 'DUE' && m.loan_id === id && isOverDue(m.installment_date));

			return test;
		};

		const currentNav = localStorage.getItem('currentNav');

		return (
			<section id="list-wrapper">
				<PageHeaderTitle
					className="p-x-16"
					isMobile={true}
					title={
						this.props.parentState._pageHeaderTitle?.toLowerCase() === 'offers' ||
						this.props.parentState._pageHeaderTitle?.toLowerCase() === 'requests'
							? `Loan ${this.props.parentState._pageHeaderTitle}`
							: `${this.props.parentState._pageHeaderTitle} Loans`
					}
					subTitle={
						this.props.parentState._pageHeaderTitle?.toLowerCase() === 'offers' ||
						this.props.parentState._pageHeaderTitle?.toLowerCase() === 'requests'
							? this.props.parentState._pageHeaderDescription
							: ''
					}
					onClick={this.props.handleBackFromList}
				/>

				{this.props.parentState._pageHeaderTitle !== 'Active' ? (
					<div className="dashboard-table-wrapper">
						<div
							className="dashboard-table-header-wrapper"
							style={{ backgroundColor: this.props.parentState._tableColor }}>
							{columns.first_type.map((column, index) => (
								<div key={index} className="dashboard-table-header-cell">
									{column}
								</div>
							))}
						</div>
						<div className="dashboard-table-body">
							{loanObjectsData.map((data, index) => (
								<React.Fragment key={index}>
									<div className="dashboard-table-row">
										<div className="dashboard-table-cell">
											LA{String(data.id).padStart(5, '0')}{' '}
										</div>
										<div className="dashboard-table-cell">{data.name ? data.name : 'unknown'}</div>
										<div className="dashboard-table-cell">
											{CommaSeparator(parseFloat(data.principal).toFixed(2))}
										</div>
									</div>
									<div className="dashboard-table-row last-tr">
										<div className="dashboard-table-cell" style={{ textAlign: 'center' }}>
											<button
												style={{
													backgroundColor: this.props.parentState._tableColor
												}}
												onClick={() => {
													this.props.openLoanDetail(data.id);
												}}>
												Review Loan Details
											</button>
										</div>
									</div>
								</React.Fragment>
							))}
						</div>
					</div>
				) : (
					<section className="dashboard-table-wrapper active-status-table-wrapper">
						{loanObjectsData.map((data, index) => {
							//the issue comes from the fact that the date is not in the correct format, so we need to add ".000Z" to the end of the date if it doesn't have it
							let installmentDate = data.next_installment_details
								? data.next_installment_details.installment_date
								: data.first_installment_date;

							// Check if the installment_date has a timezone format
							const hasTimezoneFormat = /Z$/.test(installmentDate);

							// If it doesn't have a timezone format, append ".000Z"
							if (!hasTimezoneFormat) {
								installmentDate = `${installmentDate}Z`;
							}
							return (
								<div className="active-status-dashboard-row" key={index}>
									<section
										className="active-status-dashboard-table-header-wrapper"
										style={{
											backgroundColor: this.props.parentState._tableColor
										}}>
										<label>
											{getOverDueById(data.id)?.length > 0 && currentNav === 'BORROW' ? (
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														alignItems: 'center',
														gap: '5px'
													}}>
													LA{String(data.id).padStart(5, '0')}
													<ExclamationCircleFilled
														style={{ color: 'red', fontSize: '20px' }}
													/>
												</div>
											) : (
												`LA${String(data.id).padStart(5, '0')}`
											)}
										</label>
									</section>
									<section className="active-status-content-wrapper">
										<div className="active-status-content-left">
											<label>
												{this.props.tableType.toLowerCase() == 'lend'
													? 'Borrower Name'
													: 'Lender Name'}
											</label>
											<div>{data.name ? data.name : 'unknown'}</div>
										</div>
										<div className="active-status-content-right">
											<label>Loan Amount</label>
											<div>{CommaSeparator(parseFloat(data.principal).toFixed(2))}</div>
										</div>
									</section>
									{this.props.parentState._pageHeaderTitle !== 'Completed' && (
										<section className="active-status-content-wrapper">
											<div className="active-status-content-left">
												<label>Next Payment Date</label>
												<div>{GetFormat(installmentDate)}</div>
											</div>
											<div className="active-status-content-right">
												<label>Next Payment Amount</label>
												<div>
													{CommaSeparator(
														parseFloat(
															data.next_installment_details
																? data.next_installment_details.emi_amount
																: data.emi_amount
														).toFixed(2)
													)}
												</div>
											</div>
										</section>
									)}
									<section className="dashboard-button-wrapper">
										<button
											style={{
												backgroundColor: this.props.parentState._tableColor
											}}
											onClick={e => {
												e.preventDefault();
												this.props.openLoanDetail(data.id);
											}}>
											Review Loan Details
										</button>
									</section>
								</div>
							);
						})}
					</section>
				)}
				{/* <Container
                    component="main"
                    maxWidth="md"
                >
                    <TableContainer component={Paper}>
                        <Table
                            aria-label="customized table"
                            className={classes.table}
                        >
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">{t('loan_list.loan_id')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('loan_list.name')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('loan_list.loan_amount')}(₱)</StyledTableCell>
                                    <StyledTableCell align="center">{t('loan_list.status')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('loan_list.installment_amount')}(₱)</StyledTableCell>
                                    <StyledTableCell align="center">{t('loan_list.next_payment_date')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('loan_list.action')}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.LoanObjects.map(loanObject => (
                                    <StyledTableRow key={`loan-row-${loanObject.id}`}>
                                        <StyledTableCell align="center">{loanObject.id}</StyledTableCell>
                                        <StyledTableCell align="center">{loanObject.name}</StyledTableCell>
                                        <StyledTableCell align="center">{amountFormate(parseFloat(loanObject.principal).toFixed(2))}</StyledTableCell>
                                        <StyledTableCell align="center"><StateBadge state={loanObject.state} /></StyledTableCell>
                                        <StyledTableCell align="center">{amountFormate(parseFloat(loanObject.emi_amount).toFixed(2))}</StyledTableCell>
                                        <StyledTableCell align="center">{loanObject.next_installment_details ? GetFormat(loanObject.next_installment_details.installment_date) : GetFormat(loanObject.first_installment_date)}</StyledTableCell>
                                        <StyledTableCell align="center">
                                            {
                                                loanObject.state === LOAN_STATES.DECLINE && loanObject.created_by === this.props.currentUserId
                                                    ? <ButtonGroup
                                                        aria-label="contained primary button group"
                                                        color="primary"
                                                        variant="text"
                                                    >
                                                        <Link
                                                            href="#"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                this.props.openLoanDetail(loanObject.id);
                                                            }}
                                                            style={{ fontSize: 'medium' }}
                                                            variant="body2"
                                                        >
                                                            {t('loan_list.review')}
                                                        </Link>
                                                        <span>|</span>
                                                        <Link
                                                            href="#"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                this.deleteLoanRequest(loanObject.id);
                                                            }}
                                                            style={{ fontSize: 'medium' }}
                                                            variant="body2"
                                                        >
                                                            {t('buttons.delete')}
                                                        </Link> */}
				{/* <Button onClick={() => this.deleteLoanRequest(loanObject.id)} ><DeleteIcon /></Button> */}
				{/* </ButtonGroup>

                                                    : <div>
                                                        <Link
                                                            href="#"
                                                            id="text-size"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                this.props.openLoanDetail(loanObject.id);
                                                            }}
                                                            variant="body2"
                                                        >
                                                            {(()=>{
                                                                if(loanObject.state === LOAN_STATES.DRAFTED){
                                                                    return t('loan_list.draft');
                                                                }else{
                                                                    return t('loan_list.review');
                                                                }
                                                            })()}
                                                        </Link>
                                                    </div>
                                            }
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer> */}
				{/* <div className="footer-icons" id="form-opacity-none">
					<Footer />
				</div> */}
				<MobileFooter className="main_footer" onClick={this.props.handleBackFromList} />
				{/* <div className="center-button dashboard-back-button"> */}
				{/* <Fab
                            aria-label="add"
                            className={classes.submit}
                            onClick={this.props.handleBackFromList}
                            size="medium"
                            style={{ backgroundColor: 'darkblue', color: 'white' }}
                            type="submit"
                            variant="extended"
                        >
                            {t('buttons.back')}
                        </Fab> */}
				{/* <BasicButtons onClick={this.props.handleBackFromList} type="decline" text="back" /> */}
				{/* </div> */}
				{/* </Container> */}
				{this.state._isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default hot(module)(withStyles(styles)(withTranslation()(List)));
